<template>
  <div id="home_menu">
    <div class="menu_row1">
      <span class="companyLogo">
        <img :src="companyLogo" />
      </span>
      <span class="menu_project">
        <span class="platfromBtnArr">
          <span
            class="btnItem"
            v-for="item in platfromBtnArr"
            v-text="item.name"
            :key="item.key"
            :class="item.act ? 'act' : ''"
            @click="goToPlatfromPage(item)"
          ></span>
        </span>
        <span class="group_user">
          <span
            class="group_area"
            @click.stop="clickShowListPop('groupAreaFlag', groupAreaFlag)"
            :class="groupAreaFlag ? 'open' : ''"
          >
            <!-- <img src="" /> -->
            <span class="name" v-text="currGroup && currGroup.groupName"></span>
            <i class="arrow_icon el-icon-arrow-down"></i>
            <span class="list_pop">
              <span
                class="list_pop_item"
                v-for="item in groupList"
                :key="item.groupId"
                v-text="item.groupName"
                @click="changeGroup(item)"
              ></span>
            </span>
          </span>
          <span
            class="user_area"
            @click.stop="clickShowListPop('userAreaFlag', userAreaFlag)"
            :class="userAreaFlag ? 'open' : ''"
            v-if="userInfor.userAlias"
          >
            <!-- <img src="" /> -->
            <span class="name" v-text="userInfor.userAlias"></span>
            <i class="arrow_icon el-icon-arrow-down"></i>
            <span class="list_pop">
              <span
                class="list_pop_title"
                v-text="userInfor.companyName"
              ></span>
              <span
                class="list_pop_title mb20"
                v-text="userInfor.userAlias"
              ></span>
              <span
                v-if="userInfor.station"
                class="list_pop_item"
                v-text="'后台管理工作台'"
                @click="goManageWeb"
              ></span>
              <span class="list_pop_item" v-text="'修改密码'"></span>
            </span>
          </span>
        </span>
      </span>
      <span class="menu_exit" v-text="exitTitle" @click="logout"></span>
    </div>
    <div class="menu_row2">
      <div
        v-for="(menu, menuIndex) in menuData"
        :key="menu.name"
        :class="menu.name"
      >
        <span
          v-for="item in menu.arr"
          :key="item.key"
          v-text="item.name"
          @click="clickMenu(item, menuIndex)"
          :class="[item.act ? 'act' : '']"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { https_user_logout } from '@api/platfrom_base_api'
import customizeProMixins_data_mixin from '@customizeProMixins/index.js'
import customizeInd from '@customizeProMixins/getCustomizeInd'
export default {
  name: 'home_menu',
  mixins: [customizeProMixins_data_mixin],
  props: {
    groupList: {
      type: Array,
      default: () => {
        return []
      },
    },
    userInfor: {
      type: Object,
      default: () => ({
        companyName: '',
        email: '',
        identy: '',
        role: '',
        station: null,
        stationName: '',
        userAlias: '',
        userId: '',
      }),
    },
    menuData: {
      type: Array,
      default: () => {
        return [
          // {
          //   name: 'webMenu',
          //   arr: [
          //     {
          //       name: '概述',
          //       key: 'summary',
          //       act: true,
          //     },
          //     {
          //       name: '赛程',
          //       key: 'schedule',
          //       routeName: 'footballCupScheduleIndex',
          //       act: true,
          //     },
          //     {
          //       name: '球队',
          //       key: 'team',
          //       routeName: 'footballCupTeamIndex',
          //       act: false,
          //     },
          //     {
          //       name: '球员',
          //       key: 'player',
          //       routeName: 'footballCupPlayerIndex',
          //       act: false,
          //     },
          //     {
          //       name: '积分榜',
          //       key: 'leagueTable',
          //       routeName: 'footballCupLeagueTableIndex',
          //       act: false,
          //     },
          //     {
          //       name: '数据',
          //       key: 'record',
          //       routeName: '',
          //       act: false,
          //       child: [
          //         {
          //           name: '数据概览',
          //           key: 'dataOverview',
          //           act: false,
          //           routeName: 'footballCupRecordDataOverviewIndex',
          //         },
          //         {
          //           name: '球队数据',
          //           key: 'teamData',
          //           act: false,
          //           routeName: 'footballCupRecordTeamDataIndex',
          //         },
          //         {
          //           name: '球员数据',
          //           key: 'playerData',
          //           act: false,
          //           routeName: 'footballCupRecordPlayerDataIndex',
          //         },
          //       ],
          //     },
          //     {
          //       name: '场馆',
          //       key: 'sportsHall',
          //       routeName: 'footballCupSportsHallIndex',
          //       act: false,
          //     },
          //   ],
          // },
          // {
          //   name: 'openMenu',
          //   arr: [
          //     {
          //       name: '播出单',
          //       key: 'broadcastList',
          //       routeName: 'footballCupBroadcastListIndex',
          //       act: false,
          //     },
          //     {
          //       name: 'H5组件',
          //       key: 'h5Comp',
          //       routeName: 'footballCupH5CompIndex',
          //       act: false,
          //     },
          //     {
          //       name: 'API',
          //       key: 'openApi',
          //       routeName: 'footballCupOpenApiIndex',
          //       act: false,
          //     },
          //   ],
          // },
        ]
      },
    },
    currGroup: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      customizeInd,
      isOpenFlag: false,
      exitTitle: '退出',
      secMenuData: {
        key: [],
        arr: [],
      },
      groupAreaFlag: false,
      userAreaFlag: false,
      platfromBtnArr: [
        {
          name: '数据平台',
          key: 'dataPlatfrom',
          routeName: '',
          act: true,
        },
        {
          name: '数据海报',
          key: 'dataPosterPlatfrom',
          routeName: 'platfromDataPosterFull',
          act: false,
        },
        {
          name: 'AI解说',
          key: 'intelligentExplanation',
          url: 'https://data.mixtmt.com/wss/match',
          act: false,
        },
      ],
    }
  },
  created() {},
  mounted() {
    window.addEventListener('click', this.clickShowListPop)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.clickShowListPop)
  },
  computed: {
    companyLogo() {
      return require(`@src/assets/images/platfrom_${this.customizePro}/company_logo.png`)
    },
  },
  methods: {
    goToPlatfromPage(item) {
      if (item.url) {
        window.open(item.url, '_blank')
      } else {
        this.openNewWeb(this.$router, `${item.routeName}`)
      }
    },
    clickShowListPop(key, flag) {
      console.debug('clickShowListPop', key, typeof key)
      const arr = ['groupAreaFlag', 'userAreaFlag']
      if (typeof key === 'string') {
        if (key == arr[0] && this[arr[1]]) {
          this[arr[1]] = false
        } else {
          this[arr[0]] = false
        }
        this[key] = !flag
      } else {
        // 点击其他地方将小组和用户菜单收起
        arr.forEach((key) => {
          if (this[key]) {
            this[key] = false
          }
        })
      }
    },
    changeGroup(item) {
      this.$emit('changeGroupEvent', item)
    },
    clickMenu(item) {
      this.$emit('clickMenuEvent', item)
    },
    goManageWeb() {
      // 新开窗口进管理端
      const isDevPro = window.mixtmt_platfrom.envOtherOption.devPro
      const url =
        window.mixtmt_platfrom.envOtherOption[isDevPro].backendManageUrl
      window.open(url)
      // window.location.href = url
    },
    async logout() {
      //退出登录
      await https_user_logout('/api', this.$axios)
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('退出登录')
            this.$message({
              showClose: true,
              message: '用户退出登录成功',
              type: 'success',
            })
            console.debug('this.customizeInd:', this.customizeInd)
            // 跳转到登录页
            if (this.customizeInd === 0) {
              // 跳转到登录页
              this.$router.push({ name: 'platfromLoginIndex' })
            } else if (this.customizeInd === 1) {
              // console.debug('cctv 退出')
              // this.$router.push({ name: 'platfromLoginIndex' })
              let curLocationOrigin = window.location.origin
              setTimeout(() => {
                window.location = `${curLocationOrigin}/unification/unauth`
              }, 2 * 1000)
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#home_menu {
  width: 100%;
  height: auto;
  background-color: #fff;
  color: #333;
  box-shadow: 0.2vw 0.2vw 0.972vw 0.486vw rgba(60, 59, 59, 0.15);
  .menu_row1 {
    position: fixed;
    top: 0.416vw;
    left: 0;
    /* z-index: 8000; */
    z-index: 100;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    height: 3.468vw;
    font-size: 0.972vw;
    background-color: #fff;
    border-top: 1px solid #eaedf1;
    border-bottom: 1px solid #eaedf1;
    & .companyLogo,
    & .menu_exit {
      width: 9.722vw;
      text-align: center;
      height: 2.788vw;
      line-height: 2.788vw;
    }
    .companyLogo img {
      display: block;
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    & .menu_project {
      flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      .platfromBtnArr {
        width: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        .btnItem {
          width: auto;
          padding: 0 1.1vw;
          margin-right: 1.1vw;
          font-size: 1.11vw;
          line-height: 2.083vw;
          font-weight: bold;
          &.act {
            background-color: #3863ad;
            color: #fff;
            border-radius: 0.416vw;
          }
        }
      }
      .group_user {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        .user_area,
        .group_area {
          position: relative;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          margin-left: 1.388vw;
          img {
            width: 1.805vw;
            height: 1.805vw;
            border-radius: 50%;
            background-color: #fff;
            overflow: hidden;
          }
          .name {
            padding: 0 0.694vw;
            width: auto;
          }
          .arrow_icon {
            transition: transform 0.3s linear;
          }
          .list_pop {
            display: none;
            position: absolute;
            top: 3.052vw;
            left: 50%;
            z-index: 100;
            width: 10.416vw;
            height: auto;
            background-color: #fff;
            padding: 0.972vw 0;
            transform: translateX(-50%);
            border: 1px solid rgba(229, 229, 229, 1);
            border-radius: 0.556vw;
            .list_pop_title,
            .list_pop_item {
              display: block;
              padding: 0 0.972vw;
              line-height: 2.5vw;
              font-size: 0.972vw;
              color: rgba(0, 0, 0, 0.85);
              width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              text-align: center;
            }
            .list_pop_title {
              color: rgba(0, 0, 0, 0.6);
            }
            .mb20 {
              margin-bottom: 2.083vw;
            }
          }
          &.open {
            .arrow_icon {
              transform: rotate(180deg);
            }
            .list_pop {
              display: block;
            }
          }
        }
      }
    }
  }
  & .menu_row2 {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 3.884vw;
    height: 4.116vw;
    font-size: 1.111vw;
    font-weight: bold;
    padding: 1.388vw 9.722vw 0;
    color: rgba(0, 0, 0, 0.6);
    .webMenu,
    .openMenu {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      span {
        position: relative;
        margin: 0 1.736vw;
        width: auto;
        &.act {
          color: rgba(0, 0, 0, 1);
          &::before {
            bottom: -20%;
            left: 0;
            right: 0;
            background-color: rgba(0, 0, 0, 0.85);
          }
        }
        &::before {
          content: '\20';
          position: absolute;
          bottom: -20%;
          left: 51%;
          right: 51%;
          z-index: 2;
          height: 0.208vw;
          border-radius: 0.104vw;
          background-color: transparent;
          -webkit-transition-property: left, right;
          transition-property: left, right;
          -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
          -webkit-transition-timing-function: ease-out;
          transition-timing-function: ease-out;
        }
        &.hasChild::after {
          position: absolute;
          left: 110%;
          top: 50%;
          z-index: 2;
          content: '\20';
          transition: transform 0.3s linear;
          -webkit-transition: -webkit-transform 0.3s linear;
          margin-top: -0.2vw;
          width: 0;
          height: 0;
          border-left: 0.4vw solid transparent;
          border-right: 0.4vw solid transparent;
          border-bottom: 0.5vw solid rgba(100, 100, 100, 1);
        }
      }
    }
    .webMenu {
      span {
        &:first-child {
          margin: 0 1.736vw 0 0;
        }
        &:last-child {
          margin: 0 3.472vw 0 1.736vw;
        }
        &.open {
          &::after {
            transform: rotate(180deg);
          }
        }
      }
    }
    .openMenu {
      position: relative;
      &::before {
        content: '\20';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        height: 100%;
        width: 1px;
        background-color: rgba(210, 210, 210, 1);
      }
      span {
        &:first-child {
          margin: 0 1.736vw 0 3.472vw;
        }
      }
    }
  }
}
.mixtmt_pc #home_menu {
  .menu_row1 {
    .menu_project {
      .platfromBtnArr {
        .btnItem {
          &:hover {
            cursor: pointer;
            background-color: #3863ad;
            color: #fff;
            border-radius: 0.416vw;
          }
        }
      }
      .group_user {
        .user_area,
        .group_area {
          cursor: pointer;
          &:hover {
            color: rgba(51, 51, 51, 0.7);
            .list_pop {
              .list_pop_title {
                &:hover {
                  cursor: default;
                }
              }
              .list_pop_item {
                &:hover {
                  background-color: #f5f7fa;
                  color: #409eff;
                }
              }
            }
          }
        }
      }
    }
    .menu_exit {
      &:hover {
        cursor: pointer;
        color: rgba(51, 51, 51, 0.7);
      }
    }
  }
  & .menu_row2 {
    span:hover {
      color: rgba(0, 0, 0, 1);
      cursor: pointer;
      &::before {
        /* content: '\20';
        position: absolute;
        bottom: -0.347vw;
        left: 0;
        z-index: 2;
        height: 0.208vw;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.85); */

        bottom: -20%;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.85);
      }
    }
  }
}

.mixtmt_ipad #home_menu {
  .menu_row2 {
    padding: 0.972vw 3vw 0;
  }
}
</style>
